// extracted by mini-css-extract-plugin
export var container = "_gw-0";
export var segment = "_gw-2";
export var segmentActive = "_gw-3";
export var track = "_gw-1";